import { Box } from "@mui/material";
import * as React from "react";
import { CircularLoading } from "../../Loading/CircularLoading";

export interface IDashboardCardProgressProps {
    isLoading: boolean;
}

export const DashboardCardProgress = (props: IDashboardCardProgressProps) => {
    if (!props.isLoading) return null;
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%" marginTop="-40px">
            <CircularLoading />
        </Box>
    );
};